import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected/$organizationId/$flowId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$organizationId/$flowId/sessions",
      params: { organizationId: params.organizationId, flowId: params.flowId },
    });
  },
});
